import {
  Box, Container, FormControlLabel, Typography, styled,
} from '@material-ui/core';

export const ContentContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: '100vh',
});

export const FlexContainer = styled(Container)({
  flex: 1,
});

export const HeaderBox = styled(Box)({
  marginTop: 32,
  marginBottom: 40,
});

export const Title = styled(Typography)({
  marginBottom: 8,
});

export const PhoneLabel = styled(Typography)({
  fontWeight: 700,
  marginBottom: 8,
});

export const RequiredConsentLabel = styled(FormControlLabel)({
  marginTop: 12,
  marginBottom: 4,
  alignItems: 'flex-start',
});

export const OptionalConsentLabel = styled(FormControlLabel)({
  marginTop: 4,
  marginBottom: 24,
  alignItems: 'flex-start',
});

export const DividerContainer = styled(Box)({
  position: 'relative',
  marginBottom: 24,
});

export const DividerText = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: theme.palette.common.white,
  padding: '0 16px',
  color: theme.palette.text.primary,
  fontSize: 14,
}));

export const continueButtonStyles = {
  marginBottom: 24,
  borderRadius: 100,
};
